import type { PortalMessages } from "./messages.en";

export const portalNavEs: Partial<Record<keyof PortalMessages, string>> = {
  "portal.settings.activities": "Actividades de socios",
  "portal.settings.activitiesHint": "Desactivado por defecto. Active estas opciones después de aprobar los cargos de eventos, los procedimientos de comedor y el acceso de socios.",
  "portal.settings.eventsBooking": "Permitir inscripciones en línea a eventos",
  "portal.settings.diningRequests": "Permitir solicitudes de comedor en línea",
  "portal.nav.access": "Acceso de socios",
  "portal.nav.settings": "Portal de socios",
  "portal.nav.app": "App de socios",
  "portal.nav.staffViews": "Vistas del personal",
  "portal.nav.memberRequests": "Solicitudes de socios",
  "portal.mr.waitingCount_one": "{count} solicitud en espera",
  "portal.mr.waitingCount_other": "{count} solicitudes en espera",

  "portal.viewAs.button": "Ver el portal como el socio",
  "portal.viewAs.title": "Ver el portal de socios como {name}",
  "portal.viewAs.body": "Verá y podrá hacer en el portal de socios todo lo que {name} puede hacer, incluido pagar su cuenta con una tarjeta que le dicte. Nunca verá ni cambiará cómo inicia sesión. Al socio no se le avisa. El motivo que escriba, su nombre y todo lo que haga quedan registrados en el registro de auditoría.",
  "portal.viewAs.reason": "¿Por qué abre su portal?",
  "portal.viewAs.reasonHint": "Al menos {count} caracteres, por ejemplo: el socio llamó para pagar la cuenta de octubre.",
  "portal.viewAs.reasonShort": "Escriba al menos {count} caracteres.",
  "portal.viewAs.start": "Continuar",
  "portal.viewAs.readyTitle": "Su portal está listo",
  "portal.viewAs.readyBody": "Ábralo ahora: el enlace sirve una sola vez y durante un minuto. La sesión dura {minutes} minutos, o hasta que pulse Terminar sesión en la barra roja de arriba.",
  "portal.viewAs.open": "Abrir el portal del socio en una pestaña nueva",
  "portal.viewAs.opened": "Abierto en una pestaña nueva. Cierre esta ventana cuando termine.",
  "portal.viewAs.staffOnly": "Vista solo de consulta: este socio no tiene cuenta del portal; use las pantallas del personal para hacer cambios. No se crea nada para él, no se le envía nada y no se le avisa. Invitarlo es un paso aparte.",
};

export const portalEs: Partial<Record<keyof PortalMessages, string>> = {
  "apiError.request_not_routed": "Los mensajes generales van a otro rol de este club.",
  "apiError.request_closed": "Este mensaje ya está cerrado.",
  "portal.mr.title": "Solicitudes de socios",
  "portal.mr.subtitle": "Trabajos en casas y cabañas y mensajes que los socios envían desde el portal. Un trabajo se programa y se termina en su orden de trabajo; una respuesta marcada para el socio aparece en su portal. Todavía no se les envía ningún correo.",
  "portal.mr.filter.status": "Mostrar",
  "portal.mr.filter.open": "Abiertas",
  "portal.mr.filter.new": "Esperando al personal",
  "portal.mr.filter.closed": "Cerradas",
  "portal.mr.filter.all": "Todas",
  "portal.mr.filter.kind": "Tipo",
  "portal.mr.filter.allKinds": "Todos los tipos",
  "portal.mr.kind.maintenance": "Trabajos en la casa o cabaña",
  "portal.mr.kind.message": "Mensaje",
  "portal.mr.status.requested": "Solicitada",
  "portal.mr.status.scheduled": "Programada",
  "portal.mr.status.in_progress": "En curso",
  "portal.mr.status.done": "Terminada",
  "portal.mr.status.cancelled": "Cancelada",
  "portal.mr.status.new": "Nuevo",
  "portal.mr.status.open": "Respondido",
  "portal.mr.status.closed": "Cerrado",
  "portal.mr.col.request": "Solicitud",
  "portal.mr.col.from": "De",
  "portal.mr.col.status": "Estado",
  "portal.mr.col.sent": "Enviada",
  "portal.mr.none": "No hay solicitudes abiertas",
  "portal.mr.noneBody": "Cuando un socio pida un trabajo o escriba al personal en el portal, aparecerá aquí.",
  "portal.mr.noMatches": "Ninguna solicitud coincide con estos filtros",
  "portal.mr.noMatchesBody": "Pruebe con otro estado u otro tipo.",
  "portal.mr.thread": "Conversación",
  "portal.mr.staffAuthor": "{name} (personal)",
  "portal.mr.enteredByStaff": "Lo ingresó un miembro del personal en una vista del portal del socio.",
  "portal.mr.reply": "Responder al socio",
  "portal.mr.replyHint": "El socio lo lee en el portal. Todavía no se le envía un correo.",
  "portal.mr.send": "Enviar respuesta",
  "portal.mr.replied": "Respuesta enviada.",
  "portal.mr.close": "Cerrar mensaje",
  "portal.mr.closed": "Mensaje cerrado.",
  "portal.mr.noMoreReplies": "Este mensaje está cerrado. El socio puede enviar uno nuevo.",
  "portal.settings.requests": "Solicitudes de socios",
  "portal.settings.requestsBody": "Elija quién responde los mensajes generales que los socios envían desde el portal. Las solicitudes de trabajos en casas siempre pasan por las órdenes de trabajo.",
  "portal.settings.messageRole": "Los mensajes generales van a",
  "portal.settings.messageRoleAnyone": "Cualquiera con acceso a las solicitudes de socios",
  "portal.settings.messageRoleHint": "Los gerentes del club siempre pueden responderlos.",
  "portal.requests.madeInStaffView": "Hecho por {name} en una vista del personal del portal del socio. Debe aprobarlo otra persona.",
  "portal.staffViews.title": "Vistas del personal del portal de socios",
  "portal.staffViews.subtitle": "Cada vez que un miembro del personal abrió el portal de socios como un socio: quién, por qué, cuándo y cuántos cambios hizo. Al socio no se le avisa. Pulse Registro para ver cada acción de una sesión.",
  "portal.staffViews.activeOnly": "Solo las sesiones aún abiertas",
  "portal.staffViews.empty": "Aún no hay vistas del personal",
  "portal.staffViews.emptyBody": "Cuando un miembro del personal use Ver el portal como el socio en la página de un socio, aparecerá aquí.",
  "portal.staffViews.col.staff": "Miembro del personal",
  "portal.staffViews.col.member": "Socio",
  "portal.staffViews.col.reason": "Motivo",
  "portal.staffViews.col.started": "Inicio",
  "portal.staffViews.col.ended": "Fin",
  "portal.staffViews.col.state": "Estado",
  "portal.staffViews.col.actions": "Cambios hechos",
  "portal.staffViews.audit": "Registro",
  "portal.staffViews.end": "Terminar ahora",
  "portal.staffViews.ended": "Se terminó la sesión de {name}.",
  "portal.staffViews.state.unused": "Nunca se abrió",
  "portal.staffViews.state.pending": "Esperando abrirse",
  "portal.staffViews.state.active": "Abierta",
  "portal.staffViews.state.ended": "Terminada",
  "portal.staffViews.state.expired": "Tiempo agotado",
  "portal.staffViews.why.staff": "terminada por el personal",
  "portal.staffViews.why.expired": "pasaron 30 minutos",
  "portal.staffViews.why.replaced": "sustituida por una sesión más nueva",
  "portal.staffViews.why.staff_signed_out": "el miembro del personal cerró su sesión",
  "portal.staffViews.why.permission_revoked": "se quitó el permiso",
  "portal.staffViews.why.access_revoked": "se revocó el acceso o las sesiones del socio",
  "portal.staffViews.why.member_unavailable": "terminó el acceso del socio",

  "portal.tabs": "Vistas del acceso de socios",
  "portal.tabs.access": "Acceso",
  "portal.tabs.requests": "Solicitudes de cambio",
  "portal.tabs.payments": "Pagos que requieren atención",
  "portal.tabs.paymentsCount_one": "Pagos que requieren atención ({count})",
  "portal.tabs.paymentsCount_other": "Pagos que requieren atención ({count})",
  "portal.tabs.requestsCount_one": "Solicitudes de cambio ({count})",
  "portal.tabs.requestsCount_other": "Solicitudes de cambio ({count})",

  "portal.access.title": "Acceso de socios",
  "portal.access.subtitle": "Quién puede iniciar sesión en el portal de socios y en las aplicaciones. Aquí se invita a los socios; el personal nunca ve la contraseña ni el PIN de un socio.",
  "portal.access.empty": "Ningún socio coincide",
  "portal.access.emptyBody": "Cambie los filtros, o agregue socios primero.",
  "portal.filter.search": "Buscar socios",
  "portal.filter.access": "Acceso",
  "portal.filter.membership": "Membresía",
  "portal.filter.current": "Socios actuales",
  "portal.filter.inactive": "Socios inactivos",
  "portal.status.none": "Sin invitar",
  "portal.status.invited": "Invitado",
  "portal.status.active": "Activo",
  "portal.status.revoked": "Revocado",
  "portal.col.member": "Socio",
  "portal.col.email": "Correo electrónico",
  "portal.col.status": "Acceso",
  "portal.col.signIn": "Inicia sesión con",
  "portal.col.last": "Último inicio de sesión",
  "portal.col.actions": "Acciones",
  "portal.noEmail": "Sin correo registrado",
  "portal.method.password": "Contraseña",
  "portal.method.pin": "PIN",
  "portal.method.pinLocked": "PIN bloqueado",
  "portal.method.totp": "Dos pasos",
  "portal.method.link": "Enlace por correo",

  "portal.action.invite": "Invitar",
  "portal.action.resend": "Nuevo enlace",
  "portal.action.inviteFor": "Invitar a {name}",
  "portal.action.resendFor": "Enviar un nuevo enlace a {name}",
  "portal.action.resetPin": "Restablecer PIN",
  "portal.action.resetPinFor": "Restablecer el PIN de {name}",
  "portal.action.resetPassword": "Restablecer contraseña",
  "portal.action.resetPasswordFor": "Restablecer la contraseña de {name}",
  "portal.action.resetTwoFactor": "Restablecer dos pasos",
  "portal.action.resetTwoFactorFor": "Restablecer el inicio de sesión en dos pasos de {name}",
  "portal.action.revoke": "Revocar",
  "portal.action.revokeFor": "Revocar el acceso de {name}",

  "portal.invite.title": "Invitar a {name}",
  "portal.invite.again": "Enviar un nuevo enlace a {name}",
  "portal.invite.body": "El socio recibe un enlace de un solo uso para elegir cómo iniciará sesión. Se le muestra aquí, y se envía por correo si este servidor puede enviar correo.",
  "portal.invite.email": "Dirección de correo",
  "portal.invite.emailHint": "La dirección a la que va el enlace y con la que el socio inicia sesión. Por defecto, la de su ficha.",
  "portal.invite.send": "Enviar el enlace por correo al socio",
  "portal.invite.submit": "Crear el enlace",
  "portal.invite.sentTitle": "Enlace para {name}",

  "portal.link.body": "Entregue este enlace de un solo uso a {name}. No se vuelve a mostrar.",
  "portal.link.label": "Enlace de un solo uso",
  "portal.link.emailed": "También se envió por correo a {email}.",
  "portal.link.notEmailed": "No se envió por correo: cópielo y envíeselo usted al socio.",
  "portal.link.expires": "El enlace funciona una vez y caduca {date}.",
  "portal.link.copy": "Copiar el enlace",
  "portal.link.sent": "Se envió un enlace por correo a {name}.",
  "portal.link.ready": "Hay un enlace para {name} listo para copiar.",

  "portal.revoke.title": "¿Revocar el acceso de {name}?",
  "portal.revoke.body": "Se cierra su sesión en todos los dispositivos y todos sus enlaces dejan de funcionar. Al invitarlo de nuevo se restablece el acceso.",
  "portal.revoke.reason": "Motivo (opcional)",
  "portal.revoke.confirm": "Revocar el acceso",
  "portal.revoke.done": "Se revocó el acceso de {name}.",

  "portal.resetPin.title": "¿Restablecer el PIN de {name}?",
  "portal.resetPin.body": "El PIN anterior deja de funcionar ahora, y el socio recibe un enlace de un solo uso para elegir uno nuevo.",
  "portal.resetPin.linkTitle": "Enlace para elegir un nuevo PIN",
  "portal.resetPassword.title": "¿Restablecer la contraseña de {name}?",
  "portal.resetPassword.body": "Se cierra la sesión del socio en todas partes y recibe un enlace de un solo uso para elegir una nueva contraseña.",
  "portal.resetPassword.linkTitle": "Enlace para elegir una nueva contraseña",
  "portal.reset.confirm": "Crear el enlace",
  "portal.resetTwoFactor.title": "¿Desactivar el inicio de sesión en dos pasos de {name}?",
  "portal.resetTwoFactor.body": "Para un socio que perdió su teléfono y sus códigos de recuperación. Se cierra su sesión y puede prepararlo de nuevo.",
  "portal.resetTwoFactor.confirm": "Desactivarlo",
  "portal.resetTwoFactor.done": "Se desactivó el inicio de sesión en dos pasos de {name}.",

  "portal.bulk.open": "Invitar a muchos socios",
  "portal.bulk.title": "Invitar a muchos socios",
  "portal.bulk.body": "Quien coincida y tenga correo electrónico recibe un enlace por correo. Los socios sin correo, o cuya dirección ya usa otro socio, se omiten y se enumeran.",
  "portal.bulk.who": "A quién",
  "portal.bulk.active": "Socios actuales",
  "portal.bulk.inactive": "Socios inactivos",
  "portal.bulk.resend": "Enviar también un nuevo enlace a quienes fueron invitados pero no han terminado",
  "portal.bulk.preview": "Vista previa",
  "portal.bulk.send_one": "Enviar {count} invitación",
  "portal.bulk.send_other": "Enviar {count} invitaciones",
  "portal.bulk.result": "Se invitaría a {invited} de {considered} socios; {skipped} omitidos.",
  "portal.bulk.sample": "Cada socio invitado recibe este correo, con su propio nombre y enlace:",
  "portal.bulk.skipped_one": "{count} socio omitido",
  "portal.bulk.skipped_other": "{count} socios omitidos",
  "portal.bulk.sent_one": "Se envió {count} invitación.",
  "portal.bulk.sent_other": "Se enviaron {count} invitaciones.",
  "portal.skip.already_has_access": "ya tiene acceso",
  "portal.skip.no_email": "sin correo electrónico",
  "portal.skip.email_in_use": "otro socio usa esa dirección",
  "portal.skip.not_current": "no es socio actual",
  "portal.skip.revoked": "se revocó el acceso",

  "portal.requests.title": "Solicitudes de cambio",
  "portal.requests.subtitle": "Datos de contacto que los socios pidieron cambiar. No se aplica nada hasta que usted lo apruebe.",
  "portal.requests.none": "No hay nada pendiente",
  "portal.requests.noneBody": "Las solicitudes aparecen aquí cuando un socio pide cambiar su correo, teléfono o dirección.",
  "portal.requests.approve": "Aprobar",
  "portal.requests.approveFor": "Aprobar el cambio de {name}",
  "portal.requests.reject": "Rechazar",
  "portal.requests.rejectFor": "Rechazar el cambio de {name}",
  "portal.requests.approved": "Cambio aprobado para {name}.",
  "portal.requests.rejected": "Cambio rechazado para {name}.",
  "portal.requests.rejectTitle": "¿Rechazar el cambio de {name}?",
  "portal.requests.rejectBody": "El socio ve su nota junto a la solicitud.",
  "portal.requests.note": "Nota para el socio (opcional)",
  "portal.requests.empty": "vacío",
  "portal.requests.cleared": "borrado",
  "portal.field.email": "Correo electrónico",
  "portal.field.phone": "Teléfono",
  "portal.field.address": "Dirección",

  "portal.settings.title": "Portal de socios",
  "portal.settings.subtitle": "Cómo inician sesión los socios, qué ven y cómo pagan. Se aplica al portal web de socios y a las aplicaciones.",
  "portal.settings.saved": "Se guardó la configuración del portal.",
  "portal.settings.nothing": "No cambió nada.",
  "portal.settings.badAmount": "Escriba un monto, como 5.00.",
  "portal.settings.methods": "Formas de iniciar sesión",
  "portal.settings.methodsBody": "Active las que desee. A un socio con inicio de sesión en dos pasos se le pide el código de cualquier forma que use.",
  "portal.settings.password": "Correo y contraseña",
  "portal.settings.magic": "Enviarme un enlace por correo",
  "portal.settings.pin": "Número de socio y PIN",
  "portal.settings.noEmail": "El correo saliente no está activado, así que no se pueden enviar enlaces. Configúrelo en Configuración del club, Comunicaciones.",
  "portal.settings.noSecrets": "Este servidor todavía no tiene archivo de clave secreta, así que no se pueden activar los PIN.",
  "portal.settings.noMethod": "Active al menos una forma de iniciar sesión.",
  "portal.settings.magicTtl": "El enlace de acceso dura (minutos)",
  "portal.settings.inviteTtl": "El enlace de invitación dura (horas)",
  "portal.settings.household": "Cónyuges y dependientes",
  "portal.settings.householdBody": "Cada persona de una cuenta inicia sesión como ella misma. El titular de la cuenta siempre ve toda la cuenta.",
  "portal.settings.spouseSees": "Un cónyuge ve",
  "portal.settings.dependentSees": "Un dependiente ve",
  "portal.settings.seesHousehold": "Toda la cuenta: saldo, estados de cuenta, todos los cargos",
  "portal.settings.seesOwn": "Solo los cargos hechos a su nombre",
  "portal.settings.spouseCanPay": "Un cónyuge puede pagar la cuenta en línea (cuando ve toda la cuenta)",
  "portal.settings.dependentCanPay": "Un dependiente puede pagar la cuenta en línea (cuando ve toda la cuenta)",
  "portal.settings.profile": "Cambios en los datos de contacto",
  "portal.settings.editMode": "Cuando un socio cambia su correo, teléfono o dirección",
  "portal.settings.editModeHint": "De cualquier forma el cambio queda registrado. Durante la operación en paralelo con el sistema anterior, una edición dura hasta que cambie el registro de ese socio en el sistema anterior.",
  "portal.settings.editRequest": "El personal lo aprueba primero",
  "portal.settings.editDirect": "Se guarda de inmediato",
  "portal.settings.directory": "Directorio de socios",
  "portal.settings.directoryBody": "Usted decide qué pueden ver los demás socios. Los socios pueden ocultar más, nunca menos. El nombre siempre se muestra para los socios que figuran; los menores nunca figuran.",
  "portal.settings.directoryOn": "Los socios pueden buscarse entre sí",
  "portal.settings.directoryFields": "Los demás socios pueden ver",
  "portal.directory.photo": "Foto",
  "portal.directory.member_number": "Número de socio",
  "portal.directory.email": "Correo electrónico",
  "portal.directory.phone": "Teléfono",
  "portal.directory.address": "Dirección del hogar",
  "portal.directory.member_since": "Año de ingreso",
  "portal.directory.household": "Otras personas de la cuenta",
  "portal.settings.payments": "Pago en línea",
  "portal.settings.paymentsBody": "Los socios pagan su cuenta con tarjeta. Los datos de la tarjeta van del dispositivo del socio al servicio de pago; este sistema nunca los ve. Las claves del servicio de pago se guardan en la configuración del servidor, no aquí. Este servidor está en modo {mode}.",
  "portal.settings.processor": "Servicio de pago",
  "portal.processor.none": "No se ofrece",
  "portal.processor.stripe": "Stripe",
  "portal.processor.creditline": "911 Software CreditLine (todavía no disponible)",
  "portal.processor.fake": "Servicio de prueba (solo desarrollo)",
  "portal.settings.minimum": "Pago mínimo",
  "portal.settings.minimumHint": "La última parte de un saldo siempre se puede pagar.",
  "portal.settings.configured": "El servicio de pago está configurado en este servidor.",
  "portal.settings.notConfigured": "El servicio de pago todavía no está configurado en este servidor, así que los socios no pueden pagar en línea.",
  "portal.payments.title": "Pagos que requieren atención",
  "portal.payments.subtitle": "Pagos en línea que la tarjeta ya pagó pero que la contabilidad sigue rechazando, y reembolsos y disputas que informó el servicio de pagos. Nada de esto cambia la contabilidad por sí solo.",
  "portal.payments.none": "Nada requiere atención",
  "portal.payments.noneBody": "Todos los pagos en línea se registraron, y ninguno fue reembolsado ni disputado.",
  "portal.payments.reason.postFailed": "La contabilidad lo rechazó ({code})",
  "portal.payments.reason.refunded": "Reembolsado en el servicio de pagos",
  "portal.payments.reason.disputed": "Disputado por el titular de la tarjeta ({status})",
  "portal.payments.refunded": "Reembolsado hasta ahora: {amount}",
  "portal.payments.capturedNote_one": "Se cobró la tarjeta. Se intentó registrar {count} vez; los intentos automáticos se detuvieron.",
  "portal.payments.capturedNote_other": "Se cobró la tarjeta. Se intentó registrar {count} veces; los intentos automáticos se detuvieron.",
  "portal.payments.retry": "Intentar registrar de nuevo",
  "portal.payments.posted": "El pago se registró en la cuenta.",
  "portal.payments.stillRefused": "La contabilidad todavía lo rechaza. Corrija la causa e intente de nuevo.",
  "portal.payments.resolve": "Marcar como atendido",
  "portal.payments.resolveTitle": "Pago de {name}",
  "portal.payments.resolveBody": "Anote lo que se hizo, por ejemplo el asiento de reembolso hecho en el libro. El pago sale de esta lista.",
  "portal.payments.note": "Qué se hizo",
  "portal.payments.resolved": "Marcado como atendido.",
  "portal.protected.label": "Conservado frente a la importación de Jonas",
  "portal.protected.release": "Liberar {field}",
  "portal.protected.released": "Liberado. La próxima importación escribirá el valor de Jonas.",
  "portal.settings.publicUrl": "Dirección web para los enlaces de los correos",
  "portal.settings.publicUrlHint": "Por ejemplo https://socios.suclub.example. Los enlaces de inicio de sesión y restablecimiento de los correos empiezan con esta dirección; debe ser https y un host que el servidor permita.",
  "portal.settings.noLinks": "Todavía no se pueden crear enlaces: indique esta dirección (o pídaselo a quien administra el servidor); de lo contrario no se envía ningún correo de invitación ni de acceso.",
  "portal.app.subtitle": "Publique galerías, páginas, el directorio del personal, el menú, los anuncios y las tarifas de las cabañas. Los socios ven una fila solo después de publicarla.",
  "portal.app.galleries": "Galerías",
  "portal.app.galleryName": "Nombre de la galería",
  "portal.app.published": "publicado",
  "portal.app.hidden": "oculto",
  "portal.app.photoCount_one": "{count} foto",
  "portal.app.photoCount_other": "{count} fotos",
  "portal.app.photoFor": "Foto de {name}",
  "portal.app.remove": "Quitar",
  "portal.app.staffDirectory": "Directorio del personal",
  "portal.app.group": "Grupo",
  "portal.app.announcements": "Anuncios",
  "portal.app.menu": "Menú",
  "portal.app.section": "Sección",
  "portal.app.removeSection": "Quitar sección",
  "portal.app.publishedLabel": "Publicado",
  "portal.app.add": "Añadir",
  "portal.app.pages": "Páginas",
  "portal.app.title": "Título",
  "portal.app.text": "Texto",
  "portal.app.link": "Enlace",
  "portal.app.linkHint": "Opcional. Úselo para un folleto. Debe empezar por https://",
  "portal.app.addPage": "Añadir página",
  "portal.app.addAnnouncement": "Añadir anuncio",
  "portal.app.name": "Nombre",
  "portal.app.jobTitle": "Cargo",
  "portal.app.phone": "Teléfono",
  "portal.app.addPerson": "Añadir persona",
  "portal.app.removeGroup": "Quitar grupo",
  "portal.app.item": "Elemento",
  "portal.app.opens": "Abre",
  "portal.app.choice": "Selección",
  "portal.app.choose": "Elegir",
  "portal.app.addItem": "Añadir elemento",
  "portal.app.rateDefaultTitle": "Habitaciones de las cabañas",
  "portal.app.rateDefaultHigh": "Temporada alta",
  "portal.app.rateDefaultLow": "Temporada baja",
  "portal.app.rateCard": "Tarifas",
  "portal.app.rateSheetError": "Cada línea de habitación necesita un nombre y dos precios, separados por |.",
  "portal.app.firstSeason": "Primera temporada",
  "portal.app.firstSeasonMonths": "Meses de la primera temporada",
  "portal.app.secondSeason": "Segunda temporada",
  "portal.app.secondSeasonMonths": "Meses de la segunda temporada",
  "portal.app.rooms": "Habitaciones",
  "portal.app.roomsHint": "Una línea sin | empieza un grupo. Una línea de habitación es: Individual | 195 | 165",
  "portal.app.saveRateCard": "Guardar tarifas",
};
